import { type ReactNode } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";

export function Dropdown({
                           id,
                           label,
                           open,
                           onToggle,
                           children,
                           className = "",
                         }: {
  id: string;
  label: string;
  open: boolean;
  onToggle: (id: string, element: EventTarget) => void;
  children: ReactNode;
  className?: string;
}): ReactNode {
  return (
    <button
      className={`dropdown ${className}`}
      onClick={e => {
        e.preventDefault();
        onToggle(id, e.currentTarget);
      }}
    >
      <div className="label">
        {label}
        <MdKeyboardArrowDown/>
      </div>
      <menu className={open ? "active" : "inactive"}>{children}</menu>
    </button>
  );
}